<template>
  <div>
    <div class="ui button" @click="nocache">reload</div>
    <div class="ui button" @click="clear">clear LocalStorage</div>
  </div>
</template>

<script>
export default {
  name: 'Debug',
  methods: {
    nocache () {
      var script = document.createElement('script')
      document.getElementsByTagName('head')[0].appendChild(script)
      script.src = '/app.js?ts=' + new Date().getTime()
    },
    clear () {
      console.log('vuex', window.localStorage.getItem('vuex'))
      window.localStorage.removeItem('vuex')
      var reload = window.confirm('Do you want to reload?')
      if (reload) {
        window.location.reload()
      }
    }
  }
}
</script>

<style scoped lang="less">
</style>
